const formatExpressToApiGWPath = (path) => {
  const pathArray = path.split('/');
  const updateArray = [];
  for (const item of pathArray) {
    if(item && item[0] === ':') updateArray.push(`{${item.substring(1)}}`);
    else updateArray.push(item);
  }
  return `${updateArray.join('/')}/`;
};

exports.formatExpressToApiGWPath = formatExpressToApiGWPath;